import api from './api';

/*
 * API client for PEOPLE — the person-profile screen, reached by tapping someone
 * in a group's Members tab. Read-only; the counterpart of ./pets.js.
 *
 * Endpoints (see ../listful-api/docs/DECISIONS.md "Person profiles"):
 *   GET /users/{user}          profile header — id, name, avatar, birthday.
 *                              Deliberately NO email/phone.
 *   GET /users/{user}/wishes   their wish list, SCOPED TO THE VIEWER: only
 *                              wishes shared into a group you're also in.
 *                              Optional ?group_id= narrows to one group.
 *
 * Both 403 unless you share a group with them.
 *
 * Two things the API guarantees that the UI must not undo:
 *   - Pet wishes are excluded here; they live on the pet's own profile.
 *   - Owner-blindness still applies. Viewing your OWN profile returns your
 *     purchased wishes still present and masked as `active`, so the UI must
 *     render the owner branch (no claim/purchase state, no gifting buttons)
 *     whenever wish.user_id is the signed-in user.
 *
 * Each function returns the already-unwrapped payload: the shared axios instance
 * (`services/api.js`) strips the `{ success, data, ... }` envelope.
 */

// GET /users/{userId} — the profile header.
export async function getPerson(userId) {
    const res = await api.get(`/users/${userId}`);
    return res.data;
}

// GET /users/{userId}/wishes — their wish list as the viewer may see it.
// `groupId` (optional) narrows to a single group; the API rejects a group you
// aren't a member of, so it can only ever shrink what you'd see anyway.
export async function getPersonWishes(userId, groupId = null) {
    const res = await api.get(`/users/${userId}/wishes`, {
        params: groupId ? { group_id: groupId } : undefined,
    });
    return res.data;
}
